module.exports = __webpack_public_path__ + "static/img/news4.0cf0841.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/news4.jpg
// module id = O0ro
// module chunks = 1